<main class="app-shell">
  <kc-sidebar-container
    [sidebarOpen]="!isMobile() && leftSidebarOpened()"
    [minWidth]="sidebarMinWidth()"
  >
    @if (!isMobile()) {
      <kc-sidebar-content
        slot="sidebar"
        [width]="sidebarWidth()"
        [minWidth]="sidebarMinWidth()"
        [isOpen]="leftSidebarOpened()"
      >
        <kcc20-defi-left-sidebar
          [sidebarOpen]="leftSidebarOpened()"
          (sidebarToggle)="setLeftSidebarOpen($event)"
        />
        <kc-icon-button
          class="toggle-button"
          [class.toggle-button--opened]="leftSidebarOpened()"
          slot="toggle"
          icon="chevron-right"
          size="sm"
          variant="default"
          ariaLabel="Toggle navigation"
          (buttonClick)="toggleLeftSidebar()"
        />
      </kc-sidebar-content>
    }

    <section slot="content" class="app-content">
      <kcc20-defi-nav-bar />

      <div id="route-content" class="route-content">
        <router-outlet />
      </div>
    </section>
  </kc-sidebar-container>

  @if (isMobile()) {
    <nav class="mobile-tabbar" aria-label="Primary navigation">
      @for (item of mobileNavItems; track item.path) {
        <a
          [routerLink]="item.path"
          [class.active]="isMobileNavActive(item)"
          [attr.aria-current]="isMobileNavActive(item) ? 'page' : null"
        >
          <kc-icon [iconClass]="item.iconClass" size="sm" />
          <span>{{ item.label }}</span>
        </a>
      }
    </nav>
  }

  <kcc20-kaspa-com-web-wallet-iframe />
  <kcc20-wallet-operation-task-overlay />
  <kcc20-snackbar-top-layer />

  @if (walletManager.showLoginModalState()) {
    <div
      class="wallet-modal-backdrop"
      (click)="walletManager.clearConnection()"
    >
      <div class="wallet-modal" (click)="$event.stopPropagation()">
        <kcc20-wallet-connect />
      </div>
    </div>
  }

  @if (walletManager.showCookieConsentModal()) {
    <div
      class="wallet-modal-backdrop"
      (click)="walletManager.showCookieConsentModal.set(false)"
    >
      <div class="cookie-modal-card" (click)="$event.stopPropagation()">
        <kcc20-cookie-consent-modal />
      </div>
    </div>
  }

  <kcc20-cookie-consent-banner />
</main>
